import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';

import {updateData} from '../../../routers/data'
import {fetchCalc} from '../../../routers/settings'
import InputText from '../../components/inputText'
import InputSelect from '../../components/inputSelect'
import {FielsFilter} from '../functions'

class formVehiculo extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  state = {
    calc: false,
  };

  loadCalc = (name) => {
    const filter = ['export', 'length', 'displacement']
    if (filter.indexOf(name) >=0){
      this.setState({calc: true});
    }
  }

  componentDidUpdate() {
    if (this.state.calc){
      this.props.fetchCalc(this.props.data, this.props.settings)
      this.setState({calc: false});
    }
  }

  onChange = (name, value, title, id) =>{
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].dataresume

    const key = (this.props.name + this.props.index).toLowerCase()
    const values = this.props.data[key]

    //Detect errors and save in state the message
    const result = FielsFilter(langPlace, name, value, values)

    if (result.isError){
      this.props.updateData({errors: {...this.props.data.errors, [id]: result}})
    } else if (this.props.data.errors[id] !== undefined) {
      delete this.props.data.errors[id]
      this.props.updateData({errors: {...this.props.data.errors}})
    }

    //Save values in state
    this.props.updateData({[key]: {...values, [name]: value}})
    this.loadCalc(name)
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].dataresume
    const langNames = languages[langUrl].dataresume.names
    const { yesno, length, displacement } = languages[langUrl]

    const errors = this.props.errors
    const {index, name} = this.props
    const key = (this.props.name + this.props.index).toLowerCase()
    const values = this.props.data[key]

    return (
      <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12 form-vehicles '>

          <div className='form-header'>
            <p className='title'>{langPlace.vehicle}</p>
            <p className='subtitle'>{`${langPlace[name]} #${index}`}</p>
          </div>

          <div className='col-md-6 col-sm-12 no-padding'>
            <InputText name='brand' title={langNames.brand} value={values} errors={errors} section={key} onChange={this.onChange}/>
          </div>
          <div className='col-md-6 col-sm-12 no-padding'>
            <InputText name='model' title={langNames.model} value={values} errors={errors} section={key} onChange={this.onChange}/>
          </div>
          <div className='col-md-5 col-sm-12 no-padding'>
            <InputText name='licensePlate' title={langNames.licensePlate} value={values} errors={errors} section={key} onChange={this.onChange}/>
          </div>
          <div className='col-md-7 col-sm-12 no-padding'>
            {(name === 'car')?
              // TODO: disable 'vehículo de exportación' sí/no dropdown
              <InputSelect style="display:none" name='exported' title={langNames.exported} value={values} array={yesno} errors={errors} section={key} onChange={this.onChange}/>
            :(name === 'motorcycle')?
              <InputSelect name='displacement' title={langNames.displacement} value={values} array={displacement} errors={errors} section={key} onChange={this.onChange}/>
            :
              <InputSelect name='length' title={langNames.length} value={values} array={length} errors={errors} section={key} onChange={this.onChange}/>
            }
          </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({settings: state.settings, data: state.data, errors: state.data.errors}),
  {updateData, fetchCalc}
)(formVehiculo)



// WEBPACK FOOTER //
// ./src/shared/routes/routeData/components/formVehicle.js